import React, { useState } from "react";
import { connect } from "react-redux";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import axios from "axios";
import config from "../../config.js";
import { store } from "../../store/index.js";

function GenerateLocalPharmacyOrderModal({ onClose }) {
    const [formData, setFormData] = useState({
        digitisationRequestId: "",
        invoiceAmount: "",
        invoiceFile: null,
    });

    const [validationErrors, setValidationErrors] = useState({
        digitisationRequestId: "",
        invoiceAmount: "",
        invoiceFile: "",
    });

    const [responseMessage, setResponseMessage] = useState(null);
    const [loading, setLoading] = useState(false); 

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === "invoiceFile") {
            setFormData({ ...formData, invoiceFile: files[0] });
            validateField(name, files[0]);
        } else {
            setFormData({ ...formData, [name]: value });
            validateField(name, value);
        }
    };

    const validateField = (fieldName, value) => {
        let errorMessage = "";
        switch (fieldName) {
            case "digitisationRequestId":
                if (!value || isNaN(value)) {
                    errorMessage = "Digitisation Request ID must be a number";
                }
                break;
            case "invoiceAmount":
                if (!value || isNaN(value)) {
                    errorMessage = "Invoice Amount must be a number";
                }
                break;
            case "invoiceFile":
                // if (!value) {
                //     errorMessage = "Invoice file is required";
                // }
                // break;
            default:
                break;
        }
        setValidationErrors((prev) => ({
            ...prev,
            [fieldName]: errorMessage,
        }));
    };

    const validateForm = () => {
        let isValid = true;
        Object.entries(formData).forEach(([key, value]) => {
            validateField(key, value);
            if (validationErrors[key] !== "") {
                isValid = false;
            }
        });
        return isValid;
    };

    const generateLocalPharmacyOrder = async (payload) => {
        try {
            const headers = {};
            const state = store.getState();
            if (state.user.token) {
                headers.authorization = state.user.token;
            }

            const formDataObj = new FormData();
            formDataObj.append("digitisationRequestId", payload.digitisationRequestId);
            formDataObj.append("invoiceAmount", payload.invoiceAmount);
            formDataObj.append("invoiceFile", payload.invoiceFile);
            formDataObj.append("deliveryDate", payload.deliveryDate);

            const { data: responseBody } = await axios.post(
                `${config.pharmacyService}/v2/ops/create-local-pharmacy-order`,
                formDataObj,
                {
                    headers: {
                        ...headers,
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            return responseBody;
        } catch (err) {
            if (err.response) return err.response.data;
            if (err.request) return { message: "No response from server" };
            return { message: "Error during request setup" };
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true); 
            setResponseMessage(null);

            const response = await generateLocalPharmacyOrder(formData);

            if (response.success) {
                setResponseMessage(
                    `✅ Local pharmacy order generated successfully. Order ID: ${response.newOrderId || "N/A"}`
                );
            } else {
                setResponseMessage(
                    `❌ ${response.message || "Something went wrong"}`
                );
            }

            setLoading(false); 
        } else {
            setResponseMessage("⚠️ Please fix the errors and try again.");
        }
    };

    return (
        <Modal
            isOpen={true}
            style={{
                maxWidth: "600px",
                width: "100%",
                borderRadius: "4px",
                backgroundColor: "#f8f9fa",
            }}
        >
            <ModalHeader style={{ backgroundColor: "#28a745" }} toggle={onClose}>
                <h4 className="text-center" style={{ color: "#fff", fontWeight: "bold" }}>
                    Generate Local Pharmacy Order
                </h4>
            </ModalHeader>
            <ModalBody
                style={{
                    paddingTop: "20px",
                    paddingBottom: "20px",
                    paddingLeft: "40px",
                    paddingRight: "40px",
                }}
            >
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="digitisationRequestId">Digitisation Request ID:</label>
                        <input
                            type="number"
                            name="digitisationRequestId"
                            className="form-control"
                            value={formData.digitisationRequestId}
                            onChange={handleChange}
                            required
                        />
                        <span className="text-danger">{validationErrors.digitisationRequestId}</span>
                    </div>

                    <div className="form-group">
                        <label htmlFor="invoiceAmount">Invoice Amount:</label>
                        <input
                            type="number"
                            name="invoiceAmount"
                            className="form-control"
                            value={formData.invoiceAmount}
                            onChange={handleChange}
                            required
                        />
                        <span className="text-danger">{validationErrors.invoiceAmount}</span>
                    </div>

                    <div className="form-group">
                        <label htmlFor="deliveryDate">Delivery Date:</label>
                        <input
                            type="date"
                            name="deliveryDate"
                            className="form-control"
                            value={formData.deliveryDate}
                            onChange={handleChange}
                            required
                        />
                        <span className="text-danger">{validationErrors.deliveryDate}</span>
                    </div>

                    <div className="form-group">
                        <label htmlFor="invoiceFile">Invoice File:</label>
                        <input
                            type="file"
                            name="invoiceFile"
                            className="form-control"
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={handleChange}
                        />
                        <span className="text-danger">{validationErrors.invoiceFile}</span>
                    </div>

                    <div className="text-center">
                        <button type="submit" className="btn btn-success" disabled={loading}>
                            {loading ? (
                                <>
                                    <span
                                        className="spinner-border spinner-border-sm me-2"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                    Processing...
                                </>
                            ) : (
                                "Generate Order"
                            )}
                        </button>
                    </div>
                </form>

                {responseMessage && !loading && (
                    <div className="mt-3 p-2 text-center border rounded bg-light">
                        <pre style={{ whiteSpace: "pre-wrap", margin: 0 }}>
                            {responseMessage}
                        </pre>
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
}

const mapStateToProps = (state) => ({
    authToken: state.user.authToken,
    user: state.user,
});

export default connect(mapStateToProps)(GenerateLocalPharmacyOrderModal);
